import React from 'react';

const reasons = [
  {
    icon: '🧠',
    title: 'Expertise in Databricks',
    desc: 'We bring hands-on expertise in Databricks lakehouse architecture, Delta Live Tables, MLflow, and Unity Catalog — gained through real enterprise project delivery.',
  },
  {
    icon: '⚡',
    title: 'Expertise in Power Platform',
    desc: 'We bring deep knowledge of Power BI, Power Apps, Power Automate, and Copilot Studio — designing solutions that fit your processes and data sources.',
  },
  {
    icon: '🤖',
    title: 'Expertise in AI & LLMs',
    desc: 'We bring practical experience integrating OpenAI and Anthropic Claude into business workflows — from RAG pipelines and document intelligence to AI-powered automation.',
  },
  {
    icon: '🌍',
    title: 'North America Market Knowledge',
    desc: 'We understand the regulatory landscape of Canadian and US businesses, including PIPEDA, CCPA, and SOX compliance considerations.',
  },
  {
    icon: '🔗',
    title: 'End-to-End Delivery',
    desc: 'We handle the full cycle — from requirements and architecture through implementation and knowledge transfer — so your team can own the solution.',
  },
  {
    icon: '🛡️',
    title: 'Security-Conscious by Default',
    desc: 'Every solution we design accounts for data privacy, access control, and compliance requirements from day one.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Spiked Qcumber?</h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            We bring focused expertise in the technologies that matter most — Databricks, Power Platform, and AI — applied to real business problems for North American clients.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((r, i) => (
            <div key={i} className="bg-white rounded-2xl p-7 shadow-md hover:shadow-lg transition-shadow border border-gray-100">
              <div className="text-4xl mb-4">{r.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-gray-500 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
